import { createFileRoute } from "@tanstack/react-router";

import { RequireCapability } from "@components/RequireCapability.tsx";
import { APP_VERSIONS_CAPABILITIES } from "@/AccessPermissions.ts";
import { AppVersions } from "@/features/versions/components/AppVersions.tsx";

export const Route = createFileRoute("/versions/")({
  component: () => (
    <RequireCapability all={APP_VERSIONS_CAPABILITIES}>
      <AppVersions />
    </RequireCapability>
  ),
  staticData: { breadcrumb: "common.app-versions" }
});
